(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22],{

/***/ 9369:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 9024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1776);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7280);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6631);




function RateBadge(param) {
    let { rate , textClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex items-center space-x-1 text-sm", textClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_3__/* .MdStar */ .MVI, {
                className: "relative -top-[1px] w-4 h-4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: rate
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(RateBadge));


/***/ }),

/***/ 4737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6734);

const Loading = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center justify-center py-8 rounded-lg text-zinc-700",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                "aria-hidden": "true",
                role: "status",
                className: "mr-2 w-5 h-5 text-zinc-300 animate-spin fill-primary-500",
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                        fill: "currentFill"
                    })
                ]
            }),
            "Loading..."
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);


/***/ }),

/***/ 8053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ List_reviews; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(6734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./hooks/useFetch.ts + 1 modules
var useFetch = __webpack_require__(9350);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(7832);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/Badges/Rate.badge.tsx
var Rate_badge = __webpack_require__(9024);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(9369);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./utils/utils.ts
var utils = __webpack_require__(8728);
;// CONCATENATED MODULE: ./components/Reviews/Review.card.tsx






const ReviewCard = (param)=>{
    let { text , author , publishedAt , score  } = param;
    var _author_avatar, _author_avatar1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-6 gap-3 items-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-6 md:col-span-2 lg:col-span-1 flex-wrap flex flex-row items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-none relative w-12 aspect-square mr-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 48,
                            height: 48,
                            loading: "lazy",
                            className: "rounded-full",
                            src: ((_author_avatar = author.avatar) === null || _author_avatar === void 0 ? void 0 : _author_avatar.url) || (0,utils/* resolvedPublicPath */.dO)("review.svg"),
                            alt: ((_author_avatar1 = author.avatar) === null || _author_avatar1 === void 0 ? void 0 : _author_avatar1.alt) || "".concat(author.firstName, " ").concat(author.lastName)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                className: "font-medium capitalize mb-2 md:mb-0 md:max-w-[120px] lg:max-w-[80px] xl:max-w-[120px] truncate",
                                children: [
                                    author.firstName,
                                    " ",
                                    author.lastName.charAt(0)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between md:flex-col md:justify-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-[#46474a] md:order-1 order-3",
                                        children: dayjs_min_default()(publishedAt).format("DD/MM/YYYY")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "order-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rate_badge/* default */.Z, {
                                            textClassName: "text-primary-500",
                                            rate: score
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto p-5 rounded-xl rounded-tl-none bg-primary-50 w-full col-span-6 md:col-span-4 lg:col-span-5 break-word",
                children: text
            })
        ]
    });
};
/* harmony default export */ var Review_card = (/*#__PURE__*/(0,react.memo)(ReviewCard));

// EXTERNAL MODULE: ./components/Loading/Loading.tsx
var Loading = __webpack_require__(4737);
// EXTERNAL MODULE: ./hooks/useVirtualized.ts + 1 modules
var useVirtualized = __webpack_require__(1764);
;// CONCATENATED MODULE: ./containers/Reviews/List.reviews.tsx






function ReviewsList(param) {
    let {} = param;
    const { data: businessProfile  } = (0,useFetch/* useBusinessProfile */.jB)();
    const widgetSetting = businessProfile === null || businessProfile === void 0 ? void 0 : businessProfile.data;
    const { data , error , fetchNextPage , status , isFetchingNextPage , isFetching  } = (0,useFetch/* useReviews */.DF)(widgetSetting === null || widgetSetting === void 0 ? void 0 : widgetSetting.key);
    const reviews = (0,react.useMemo)(()=>data ? data.pages.flatMap((page)=>page.items) : [], [
        data
    ]);
    const lastPage = data === null || data === void 0 ? void 0 : data.pages[data.pageParams.length - 1];
    const hasNextPage = (lastPage === null || lastPage === void 0 ? void 0 : lastPage.hasNext) || false;
    const { parentRef , rowVirtualizer , items , totalSize  } = (0,useVirtualized/* default */.Z)({
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
        length: reviews.length
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            status === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : status === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    "Error: ",
                    error.message
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: parentRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full",
                    style: {
                        height: totalSize
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full",
                        style: {
                            transform: "translateY(".concat(items[0].start - rowVirtualizer.options.scrollMargin, "px)")
                        },
                        children: items.map((virtualRow)=>{
                            const isLoaderRow = virtualRow.index > reviews.length - 1;
                            const item = reviews[virtualRow.index];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                "data-index": virtualRow.index,
                                ref: rowVirtualizer.measureElement,
                                className: "py-4",
                                children: isLoaderRow ? hasNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : "Nothing more to load" : /*#__PURE__*/ (0,jsx_runtime.jsx)(Review_card, {
                                    text: item.comment,
                                    publishedAt: item.publishedAt,
                                    score: item.score,
                                    author: item.author
                                })
                            }, virtualRow.key);
                        })
                    })
                })
            }),
            isFetching && !isFetchingNextPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}) : null
        ]
    });
}
/* harmony default export */ var List_reviews = (/*#__PURE__*/(0,react.memo)(ReviewsList));


/***/ }),

/***/ 1764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useVirtualized; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(1776);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-virtual/build/lib/index.mjs + 4 modules
var lib = __webpack_require__(3398);
;// CONCATENATED MODULE: ./hooks/useOnScreen.ts

const useOnScreen = function(ref) {
    let rootMargin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0px";
    const [isIntersecting, setIntersecting] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            // Update our state when observer callback fires
            setIntersecting(entry.isIntersecting);
        }, {
            rootMargin
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
    }, [
        ref,
        rootMargin
    ]); // Empty array ensures that effect is only run on mount and unmount
    return isIntersecting;
};
/* harmony default export */ var hooks_useOnScreen = (useOnScreen);

;// CONCATENATED MODULE: ./hooks/useVirtualized.ts



const useVirtualized = (param)=>{
    let { isFetchingNextPage , hasNextPage , length , options , fetchNextPage  } = param;
    const parentOffsetRef = (0,react.useRef)();
    const parentRef = (0,react.useRef)(null);
    const onScreen = hooks_useOnScreen(parentRef);
    const opts = {
        count: hasNextPage ? length + 1 : length,
        scrollMargin: parentOffsetRef.current,
        estimateSize: ()=>100,
        initialOffset: 3,
        overscan: 2,
        ...options
    };
    (0,react.useEffect)(()=>{
        if (onScreen) {
            var _parentRef_current;
            var _parentRef_current_offsetTop;
            parentOffsetRef.current = (_parentRef_current_offsetTop = (_parentRef_current = parentRef.current) === null || _parentRef_current === void 0 ? void 0 : _parentRef_current.offsetTop) !== null && _parentRef_current_offsetTop !== void 0 ? _parentRef_current_offsetTop : 0;
        }
    }, [
        parentRef,
        onScreen
    ]);
    const rowVirtualizer = (0,lib/* useWindowVirtualizer */.hO)(opts);
    const totalSize = rowVirtualizer.getTotalSize();
    const items = rowVirtualizer.getVirtualItems();
    (0,react.useEffect)(()=>{
        const [lastItem] = [
            ...items
        ].reverse();
        if (!lastItem) {
            return;
        }
        if (lastItem.index >= length - 1 && hasNextPage && !isFetchingNextPage && onScreen) {
            fetchNextPage();
        }
    }, [
        hasNextPage,
        fetchNextPage,
        length,
        isFetchingNextPage,
        items,
        onScreen
    ]);
    return {
        parentRef,
        rowVirtualizer,
        items,
        totalSize
    };
};
/* harmony default export */ var hooks_useVirtualized = (useVirtualized);


/***/ }),

/***/ 8728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ isProd; },
/* harmony export */   "Ee": function() { return /* binding */ generateSocialShare; },
/* harmony export */   "Eh": function() { return /* binding */ toSearchEngineFriendlyWords; },
/* harmony export */   "Hl": function() { return /* binding */ getNameOfDay; },
/* harmony export */   "UT": function() { return /* binding */ generateSectionLabel; },
/* harmony export */   "V5": function() { return /* binding */ formatTime24; },
/* harmony export */   "_2": function() { return /* binding */ generateBookingURL; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "dO": function() { return /* binding */ resolvedPublicPath; }
/* harmony export */ });
/* harmony import */ var lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7167);
/* harmony import */ var lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(194);


const DOMAIN_URL = "https://www.yocale.com";
const getNameOfDay = ()=>{
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const d = new Date();
    return days[d.getDay()];
};
const generateBookingURL = (param)=>{
    let { uniqueIdentifier , type , id , locale  } = param;
    let link = "".concat(DOMAIN_URL, "/widget/").concat(uniqueIdentifier, "?lng=").concat(locale);
    switch(type){
        case "location":
            link += "&locations=".concat(id);
            break;
        case "provider":
            link += "&op=~".concat(id);
            break;
        case "service":
            link += "&op=".concat(id, "~");
            break;
        default:
            break;
    }
    return link;
};
const generateSocialShare = (param)=>{
    let { type , businessName , url  } = param;
    let link = "";
    switch(type){
        case "facebook":
            link += "https://facebook.com/sharer/sharer.php?u=".concat(url);
            break;
        case "twitter":
            link += "https://twitter.com/intent/tweet/?text=".concat(businessName, "&url=").concat(url);
            break;
        default:
            break;
    }
    return link;
};
const formatTime24 = (timeString)=>{
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
};
const truncateString = function(str) {
    let num = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 13;
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + "...";
};
const isProd = ()=>"production" === "production";
const resolvedPublicPath = (path)=>isProd() ? "/b/".concat(path) : "/".concat(path);
const toSearchEngineFriendlyWords = (input)=>{
    return encodeURIComponent((0,lodash_es_kebabCase__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,lodash_es_lowerCase__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(input)));
};
const generateSectionLabel = function(label, fallback) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 13;
    if (!label) return fallback;
    return truncateString(label, limit);
};



/***/ })

}]);